export default __webpack_public_path__ + "static/media/cosh2.aefa1a41.jpg";